import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'
import router from './router'

const pinia = createPinia()
const app = createApp(App)
if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration({ router })],
  })
  pinia.use(Sentry.createSentryPiniaPlugin())
}

app.use(pinia)
app.use(router)

app.mount('#app')
